<script setup lang="ts">
import { api } from "@/api";
import { useFacade } from "@/facades";
import { PV, VR } from "@/widgets";
import { alerts } from "../../common/alert.common";
import { FinancePaymentRoutes } from "../../pages/finance_payment/finance_payment.route";

const props = defineProps<{
    prev: string;
    invoiceId: string;
}>();

const f = useFacade();

async function waiveInvoice() {
    const msg = `Apakah anda yakin akan mengabaikan tagihan ini?\nAksi ini tidak dapat dibatalkan.`;

    if (await alerts.confirm.warningText({ title: "PERHATIAN", text: msg })) {
        await api.financeInvoice
            .waive(props.invoiceId)
            .onSuccess(alerts.basic.success(f.route.reload))
            .onFailure(alerts.basic.failure())
            .execute();
    }
}

async function cancelInvoice() {
    const msg = `Apakah anda yakin akan membatalkan tagihan ini?\nAksi ini tidak dapat dibatalkan.`;

    if (await alerts.confirm.warningText({ title: "PERHATIAN", text: msg })) {
        await api.financeInvoice
            .cancel(props.invoiceId)
            .onSuccess(alerts.basic.success(f.route.backTo(props.prev)))
            .onFailure(alerts.basic.failure())
            .execute();
    }
}
</script>

<template>
    <VR.RouterLink v-if="f.isTesting" class="rns-big-button" :to="`/payment/${props.invoiceId}`">
        <PV.Button class="w-full" severity="warn"><label>Bayar Lewat Xendit</label></PV.Button>
    </VR.RouterLink>

    <VR.RouterLink class="rns-big-button" :to="FinancePaymentRoutes.to.create(props.invoiceId)">
        <PV.Button class="w-full"><label>Tambah Pembayaran</label></PV.Button>
    </VR.RouterLink>

    <PV.Button class="rns-big-button" severity="help" @click="waiveInvoice">
        <label>Abaikan Tagihan</label>
    </PV.Button>

    <PV.Button class="rns-big-button" severity="danger" @click="cancelInvoice">
        <label class="">Batalkan Tagihan</label>
    </PV.Button>
</template>

<style scoped>
@reference "@/styles/main.css";

.rns-big-button {
    @apply w-full md:w-auto text-white font-bold! rounded-md shadow-sm hover:cursor-pointer;
}

.rns-big-button label {
    @apply hover:cursor-pointer;
}
</style>
